<script lang="ts" setup>
import LogoComponent from '#assets/crf-logo-horizontal.svg?component';

defineProps({
  title: { type: String, required: true }
});
</script>

<template>
  <div class="flex flex-col min-h-screen">
    <div class="p-4 flex gap-x-4 justify-center border-b border-persistent-border-main-primary">
      <div class="border border-border-main-secondary rounded px-4 py-3">
        <LogoComponent />
      </div>
      <div class="border-l border-border-main-secondary pl-4 font-bold flex items-center">
        {{ title }}
      </div>
    </div>
    <div class="grow relative h-full">
      <slot />
    </div>
  </div>
</template>
